var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7406 6.13135C5.29685 8.30635 4.1156 10.8001 4.1156 13.1251C4.1156 15.2137 4.94529 17.2167 6.42213 18.6936C7.89898 20.1704 9.90202 21.0001 11.9906 21.0001C14.0792 21.0001 16.0822 20.1704 17.5591 18.6936C19.0359 17.2167 19.8656 15.2137 19.8656 13.1251C19.8656 8.2501 16.4906 4.5001 13.7531 1.77197L10.4906 8.6251L6.7406 6.13135Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.81492d8cd6dba9283d04883e581f347c.svg";
export { ForwardRef as ReactComponent };